import { roles } from "constants/index";

export const rolesAdd = [roles.admin, roles.regionManager, roles.viceRegionManager, roles.qs]

export const rolesActions = [roles.admin, roles.regionManager, roles.viceRegionManager, roles.qs]

export const rolesExport = [roles.admin]